import './js/ajax';
import './js/modal';
import './js/form-manipulation';
import './js/lib/check-toggle';
import './js/lib/selectable-rows';
import './js/lib/movable-rows';
import './js/tabs'
import './js/wp-media/wp-media'
import './js/evidence-skol/modal-helper';
import './js/evidence-skol/editable-group';
import './js/evidence-skol/detail-mobile-accordion';
import './js/data-table-tooltip-popover';
import './js/lib/data-table';
// import './js/air-date-picker';
